"use client";

import { domAnimation, LazyMotion } from "motion/react";
import type * as React from "react";

/**
 * Loads `domAnimation` only, so an `m.*` that uses `layout`, drag or pan needs
 * `<LazyMotion features={domMax}>` instead. An `m` with no provider above it never animates,
 * so each component that uses `m` wraps its own tree.
 */
export function MotionFeatures({ children }: { children: React.ReactNode }) {
	return <LazyMotion features={domAnimation}>{children}</LazyMotion>;
}
